import ServicesComp from '../components/servicesComp';

const Services = () => {
    return <ServicesComp />;
};

export default Services;
